import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ITemperature {
  temperature: string | number;
  temperatureId: number;
}

interface TemperatureStore {
  selectedTemperature2: ITemperature;
  setSelectedTemperature2: (temperature: ITemperature) => void;
  resetTemperature2: () => void;
}

const useTemperatureSecondStore = create<TemperatureStore>()(
  persist(
    (set) => ({
      selectedTemperature2: { temperature: '30°C', temperatureId: 3 }, // Default value

      setSelectedTemperature2: (temperature) =>
        set({ selectedTemperature2: temperature }),

      resetTemperature2: () =>
        set({
          selectedTemperature2: { temperature: '30°C', temperatureId: 3 },
        }),
    }),
    {
      name: 'temperature-second-storage', 
      partialize: (state) => ({
        selectedTemperature2: state.selectedTemperature2,
      }),
    }
  )
);

export default useTemperatureSecondStore;
